export * from './order-info-blocks.module';
export * from './components/order-delivery-info-block/order-delivery-info-block.component';
export * from './components/order-customer-info-block/order-customer-info-block.component';
